export default "__VITE_ASSET__9BvHxCEa__"